import { flushSync } from 'react-dom';
import { defaultScheduler, notifyManager, QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: window.env.RIDEIQ_ENVIRONMENT === 'local',
    },
  },
});

// flushSync alone can't help here: a cache write reaches useQuery subscribers through two
// chained setTimeout(0) hops in notifyManager; forcing the scheduler synchronous collapses both.
export const flushQueryWriteSync = (write: () => void): void => {
  notifyManager.setScheduler((callback) => callback());
  try {
    flushSync(write);
  } finally {
    notifyManager.setScheduler(defaultScheduler);
  }
};
